import React from 'react';
import { createRoot } from 'react-dom/client';
import Pricing from '@/components/Pricing.jsx';

document.addEventListener('DOMContentLoaded', () => {
    const root = createRoot(document.getElementById('pricing'));
    root.render(<Pricing />);
});
